import React from 'react'

export default function PageNotFound() {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            404 - Page Not Found
        </div>
    )
}
